import { useEffect, useState } from 'react';

/**
 * Returns a debounced version of `value` — only updates `delayMs` after the
 * caller stops changing it. Use for search inputs to avoid firing a request
 * on every keystroke.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
